export enum LoginSignupFormType {
  phoneNumber = "phoneNumber",
  firstName = "firstName",
  lastName = "lastName",
  vuaId = "vuaId",
  pin = "pin",
}
